var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49506 4.1232C1.57458 7.33639 3.13449 12.3086 7.42326 16.6172C11.6208 20.834 16.8171 22.4106 19.8922 19.5495C21.5745 17.9841 21.3259 15.2121 19.2476 13.3596C17.3688 11.7631 14.4159 11.4866 12.534 13.2534C11.8999 12.7197 11.3599 12.0895 10.7801 11.5C12.4062 9.79409 12.4012 6.82426 10.7246 4.82113C8.83975 2.56904 5.9807 2.48865 4.49506 4.1232ZM9.34619 5.975C10.4047 7.23972 10.5462 9.2558 9.29694 10.4341C8.6676 11.0002 8.05323 11.334 10.3282 13.6475C12.7828 16.1437 13.0889 15.268 13.7283 14.5986C14.7327 13.5896 16.6995 13.4965 18.0515 14.7016C19.5467 16.0344 19.3847 17.5661 18.6677 18.2333C16.449 20.2977 12.2001 18.8678 8.69723 15.3489C5.1944 11.8299 3.63985 7.73682 5.82526 5.33239C6.33259 4.7742 7.92364 4.27532 9.34619 5.975Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.00003C18.9971 2.00003 19.4 2.40297 19.4 2.90003V4.60002H21.1C21.597 4.60002 22 5.00296 22 5.50002C22 5.99707 21.597 6.40002 21.1 6.40002H19.4V8.10001C19.4 8.59706 18.9971 9.00001 18.5 9.00001C18.0029 9.00001 17.6 8.59706 17.6 8.10001V6.40002H15.9C15.403 6.40002 15 5.99707 15 5.50002C15 5.00296 15.403 4.60002 15.9 4.60002H17.6V2.90003C17.6 2.40297 18.0029 2.00003 18.5 2.00003Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAddOutline);
export default __webpack_public_path__ + "static/media/phone_add_outline.d1b9983e4f56362d1083f7f19a6ce029.svg";
export { ForwardRef as ReactComponent };